export default "/my-team";
